// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

export const KPI_STATE = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  READY: 'READY',
  FAILED: 'FAILED',
  UNKNOWN: 'UNKNOWN',
};
